<template>
  <div>
    <div v-if="$has('FWS-KJSH-FKSH-TGBH')">
      <template v-if="isBatch">
        <el-button
          type="success"
          icon="el-icon-success"
          :size="formSize"
          :disabled="!multipleSelection || multipleSelection.length === 0"
          @click="handleBatchOperateState(1)"
          v-track
          trackCode='approvalPaymentApplyList-5'
        >
          批量通过
        </el-button>
        <el-button
          type="danger"
          icon="el-icon-delete-solid"
          :size="formSize"
          :disabled="!multipleSelection || multipleSelection.length === 0"
          @click="handleBatchOperateState(2)"
          v-track
          trackCode='approvalPaymentApplyList-5'
        >
          批量驳回
        </el-button>
      </template>
      <template v-else>
        <div v-if="[1, '1'].includes(current.approvalStatus)">
          <el-button
            class="table-button table-button-success"
            icon="el-icon-success"
            @click="handleOperateState(1, current)"
            v-track
            trackCode='approvalPaymentApplyList-4'
          >
            通过
          </el-button>
          <el-button
            class="table-button table-button-danger"
            icon="el-icon-delete-solid"
            @click="handleOperateState(2, current)"
            v-track
            trackCode='approvalPaymentApplyList-4'
          >
            驳回
          </el-button>
        </div>
      </template>
    </div>
    <!-- 确认/取消确认弹窗 -->
    <operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="paymentApplyObj"
      :text-config.sync="textConfig"
      :totalInfo.sync="totalInfo"
      :loading="submitLoading"
      @submit="setPaymentApplyApproval"
    />
  </div>
</template>

<script>
import { setPaymentApplyApproval, setPaymentApplyBatchApproval } from '@/api/approval/payment-apply';
import { add } from 'mathjs';

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
    multipleSelection: {
      type: Array,
      default: () => ([]),
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentApplyObj: {}, // 付款审核对象
      textConfig: {}, // 弹窗页面提示文案
      isOperateStateShow: false, // 确认/驳回弹窗
      submitLoading: false,
      // 批量操作合并信息
      totalInfo: {
        totalNum: 0, // 合计数量
        totalAmount: 0, // 合计金额
      },
    };
  },
  methods: {
    /**
     * 付款审核确认/驳回
     * paymentNo     付款单编号
     * operation     操作：1、确认 2、驳回
     * cancelRemark  驳回原因，驳回时传入
    */
    handleOperateState(operation, row) {
      this.paymentApplyObj = {
        paymentNo: row?.paymentNo || '',
        operation,
        cancelRemark: '',
      };
      const list = {
        1: {
          title: '审核通过确认',
          messageTip: '是否通过该笔付款申请？',
          isPass: true,
        },
        2: {
          title: '审核驳回',
          messageTip: '驳回原因',
          isPass: false,
          required: true,
        },
      };
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    // 付款审核列表-付款审核操作+付款审核列表-付款批量审核操作请求接口
    async setPaymentApplyApproval(params) {
      try {
        this.submitLoading = true;
        if (this.textConfig?.isBatch) { // 批量
          await setPaymentApplyBatchApproval(params);
        } else {
          await setPaymentApplyApproval(params);
        }
        this.$message.success('操作成功！');
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.$emit('success');
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
    // 批量确认操作
    handleBatchOperateState(operation) {
      const paymentNos = (this.multipleSelection || []).map((item) => item.paymentNo);
      this.paymentApplyObj = {
        paymentNos: paymentNos || [],
        operation, // 操作：1、通过 2、驳回
        cancelRemark: '', // 驳回原因，驳回时必传
      };
      const list = {
        1: {
          title: '批量审核通过确认',
          messageTip: '是否批量审核通过多笔选中的付款申请？',
          isPass: true,
          isBatch: true,
          isTotal: true,
        },
        2: {
          title: '批量审核驳回',
          messageTip: '批量驳回原因',
          isPass: false,
          isBatch: true,
          isTotal: true,
          required: true,
        },
      };
      this.textConfig = list[operation] || '-';
      this.totalInfo = {
        totalNum: this.multipleSelection.length || 0, // 合计数量
        totalAmount: (this.multipleSelection.map((item) => item.payAmount || 0) || []).reduce((prev, cur) => {
          return add(prev, cur);
        }), // 合计金额
      };
      this.isOperateStateShow = true;
    },
  },
};
</script>
